query LinksList(
  $page: Int
  $rowsPerPage: Int
  $filter: LinksFilterInput
) {
  links(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      slug
      url
      linkType
      href
      targetType
      targetId
      targetTitle
      targetUrl
      utmSource
      utmMedium
      utmCampaign
      reward {
        type
        percent
        fixedAmount
        fixedCurrency
      }
      stats {
        clicks
        views
        sales
        revenue
        reward
        currency
        registrations
      }
      createdAt
      updatedAt
    }
  }
}
